import { Breadcrumbs, Link, Typography } from "@material-ui/core";
import React from "react";
import { useDispatch, useSelector } from "react-redux";

import {
  fetchChangeFilePrefix,
  selector as fileStoreSelector,
} from "../../../store/FileStore";
import {
  fetchUpdateSelectedOfficeInfo,
  selector as officeStoreSelector,
} from "../../../store/OfficeStore";
import { SelectOfficeField } from "../../share";
import useStyles from "../useStyles";

// ファイルパスの区切り文字
const delimiterFilePath = "/";

/**
 * FolderBreadcrumbListコンポーネント.
 *
 * @return {object} コンポーネント
 */
function FolderBreadcrumbList() {
  // スタイル
  const styles = useStyles();

  // Dispatch
  const dispatch = useDispatch();

  const {
    // ファイルプレフィックス
    filePrefix,
  } = useSelector(fileStoreSelector);

  const {
    // 拠点情報一覧
    officeInfos,
    // 選択されている拠点情報
    selectedOfficeInfo,
  } = useSelector(officeStoreSelector);

  // パスからファイルパス名リストを取得（例："hoge/fuga" -> ["hoge", "fuga"]）
  const filePathNames = filePrefix.split(delimiterFilePath).filter((x) => x);
  // ファイルパス名リスト先頭の拠点名はパンくずではなく、SelectOfficeFieldで表示するため削除する
  filePathNames.shift();

  // パンくずのリンク押下時の処理
  const handleLinkClick = (path) => {
    // ファイルプレフィックスを変更
    dispatch(
      fetchChangeFilePrefix(
        selectedOfficeInfo.serialNumber + delimiterFilePath + path
      )
    );
  };

  // SelectOfficeFieldの項目クリック時の処理
  const handleSelectClick = (event) => {
    if (!event || !event.target) {
      return;
    }
    if (event.target.value) {
      dispatch(fetchUpdateSelectedOfficeInfo(event.target.value));
    } else if (event.target.dataset && event.target.dataset.value) {
      dispatch(fetchUpdateSelectedOfficeInfo(event.target.dataset.value));
    }
  };

  return (
    <Breadcrumbs className={styles.breadcrumbs}>
      <SelectOfficeField
        label="拠点名"
        value={selectedOfficeInfo.serialNumber}
        onClick={handleSelectClick}
        items={officeInfos}
      />
      {
        // パンくずリストを生成
        filePathNames.map((pathName, index) => {
          // 最後のパスかどうか（ture: 最後、false: 最後ではない）
          const isLast = index === filePathNames.length - 1;
          // リンク先のファイルパスを生成
          const path =
            filePathNames.slice(0, index + 1).join(delimiterFilePath) +
            delimiterFilePath;

          return isLast ? (
            // 最後のパスの場合はラベルのパンくず
            <Typography key={pathName} color="textPrimary">
              {pathName}
            </Typography>
          ) : (
            // 最後のパスでなはい場合はリンクのパンくず
            // eslint-disable-next-line jsx-a11y/anchor-is-valid
            <Link
              key={pathName}
              component="button"
              color="inherit"
              onClick={() => handleLinkClick(path)}
            >
              {pathName}
            </Link>
          );
        })
      }
    </Breadcrumbs>
  );
}

export default FolderBreadcrumbList;
